module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie H1 is a html <code>&lt;h1&gt;</code> text element.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;H1&gt;Your title goes here&lt;/H1&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/H1/README.md
// module id = 352
// module chunks = 0